export type ThreatLevel = "baseline" | "elevated" | "critical";

export function formatThreatLabel(level: ThreatLevel) {
  switch (level) {
    case "baseline":
      return "Baseline";
    case "elevated":
      return "Elevated";
    case "critical":
      return "Critical";
  }
}

export function formatCountdown(ms: number) {
  if (ms <= 0) {
    return "Ready to step down";
  }

  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes > 0) {
    return `${minutes}m ${seconds}s remaining`;
  }

  return `${seconds}s remaining`;
}

export function formatRelativeTime(iso: string | null | undefined, nowMs = Date.now()) {
  if (!iso) {
    return "No signal yet";
  }

  const targetMs = Date.parse(iso);
  if (Number.isNaN(targetMs)) {
    return "Unknown";
  }

  const deltaSeconds = Math.round((targetMs - nowMs) / 1000);
  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

  if (Math.abs(deltaSeconds) < 60) {
    return rtf.format(deltaSeconds, "second");
  }

  const deltaMinutes = Math.round(deltaSeconds / 60);
  if (Math.abs(deltaMinutes) < 60) {
    return rtf.format(deltaMinutes, "minute");
  }

  const deltaHours = Math.round(deltaMinutes / 60);
  if (Math.abs(deltaHours) < 24) {
    return rtf.format(deltaHours, "hour");
  }

  const deltaDays = Math.round(deltaHours / 24);
  return rtf.format(deltaDays, "day");
}

export function formatAbsoluteTime(iso: string | null | undefined) {
  if (!iso) {
    return "Unavailable";
  }

  const targetMs = Date.parse(iso);
  if (Number.isNaN(targetMs)) {
    return "Unavailable";
  }

  return new Intl.DateTimeFormat("en-GB", {
    dateStyle: "medium",
    timeStyle: "short"
  }).format(targetMs);
}
